import { PropTypes, css, styled } from '../lib/imports';

const baseStyles = () => css`
  width: 100%;
`;

const Header = styled('div')(baseStyles);

Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
